import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { SuccessComponent } from 'src/app/components/shared/components/success/success.component';
import { ICase } from '../../interfaces/case.interface';
import { CasesService } from '../../../../core/services/cases.service';

export interface IRemitDialogData {
  case: ICase;
  destinations: any[];
}

@Component({
  selector: 'app-remit-case',
  templateUrl: './remit-case.component.html',
  styleUrls: ['./remit-case.component.scss'],
})
export class RemitCaseComponent implements OnInit {
  form = this.fb.group({
    caseType: ['', Validators.required],
    description: ['', Validators.required],
    remittedFrom: [this.data.case._id],
  });

  isSingleDestination: boolean;
  selectedDestination: any = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IRemitDialogData,
    private readonly fb: FormBuilder,
    private readonly dialogRef: MatDialogRef<RemitCaseComponent>,
    private readonly caseService: CasesService,
    private readonly dialog: MatDialog
  ) {}

  ngOnInit() {
    this.isSingleDestination = this.data.destinations.length === 1;

    if (this.isSingleDestination) {
      const singleDestinationId = this.data.destinations[0].remitTo._id;
      this.form.get('caseType').setValue(singleDestinationId);
      this.onSelectionChange(singleDestinationId);
    }
  }

  onSelectionChange(caseTypeId: string) {
    this.selectedDestination = this.data.destinations.find(
      (dest) => dest.remitTo._id === caseTypeId
    );
  }

  get msg() {
    return this.isSingleDestination
      ? this.data.destinations[0].remitTo.remitMsg
      : 'Seleccione un destino para la remisión.';
  }

  cancel() {
    this.dialogRef.close();
  }

  alertDialog(message: string) {
    this.dialog.open(SuccessComponent, { data: { title: message } });
  }

  create() {
    if (this.form.invalid) {
      return;
    }
    const data = this.form.value;
    this.caseService.create(data).subscribe({
      next: () => {
        this.alertDialog('El caso se ha remitido correctamente!');
        this.dialogRef.close(true);
      },
      error: (e) => {
        console.error(e);
        this.alertDialog('Ocurrió un error al intentar remitir el caso');
      },
    });
  }
}
